import * as TooltipPrimitive from "@radix-ui/react-tooltip";

const TONES = {
  dark: ['bg-slate-800', 'fill-slate-800'],
  warn: ['bg-orange-500', 'fill-orange-500'],
  danger: ['bg-rose-600', 'fill-rose-600'],
};

export const ActionTip = ({ label, children, testId, tone = 'dark' }) => (
  <TooltipPrimitive.Root delayDuration={150}>
    <TooltipPrimitive.Trigger asChild>
      <span className="inline-flex">{children}</span>
    </TooltipPrimitive.Trigger>
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        side="top"
        sideOffset={6}
        data-testid={testId}
        className={`z-50 max-w-xs rounded-md ${TONES[tone][0]} px-2.5 py-1.5 text-xs font-medium text-white shadow-lg animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=top]:slide-in-from-bottom-1`}
      >
        {label}
        <TooltipPrimitive.Arrow className={TONES[tone][1]} width={10} height={5} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  </TooltipPrimitive.Root>
);
